import { useCustomDuplicateWorksheetProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useDuplicateWorksheetProduct() {
  const [mutation, { loading, data, error }] = useCustomDuplicateWorksheetProductMutation({
    refetchQueries: ["customGetWorksheetProducts"],
  });
  const [duplicateWorksheetProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "duplicateWorksheetProduct",
    },
    {
      successMessage: getLocalString("worksheet.duplicate-product-success"),
      failureMessage: getLocalString("worksheet.duplicate-product-failure"),
    }
  );

  return [duplicateWorksheetProduct, context] as const;
}
